import { Box, Button, Tooltip } from "@material-ui/core";
import { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import Axios from "axios";
import { Loading } from "../../components/shared/loading";
import { UserContext } from "../../contexts/UserContext";
import { Helmet } from "react-helmet";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { useAdminStyles } from "../../components/admin/adminStyles";
import { AdminPageHeader } from "../../components/admin/AdminPageHeader";
import { useToast } from "../../components/shared/Toast";

import AddIcon from "@material-ui/icons/Add";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";
const $ = require("jquery");

export const AllServices = () => {
  const navigate = useNavigate();
  const classes = useAdminStyles();
  const toast = useToast();
  const { setUser } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    Axios.get("/api/getservices", {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.status === 200) {
        setData(res.data.data);
        setLoading(false);
        $(document).ready(function () {
          $("#services_table").DataTable({
            destroy: true,
          });
        });
      } else {
        setUser(null);
        navigate("/");
      }
    });
  };

  const toggleStatus = (id, currentStatus) => {
    const formdata = new FormData();
    formdata.append("idd", id);
    Axios.post("/api/service_status", formdata, {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.status === 200) {
        toast.success(
          currentStatus === 1 ? "Service deactivated" : "Service activated"
        );
        getData();
      } else {
        toast.error("Failed to update status");
      }
    });
  };

  if (loading) return <Loading />;

  return (
    <div>
      <Helmet>
        <title>All Services - Admin | Arawinz Soft Solutions</title>
      </Helmet>

      <AdminPageHeader
        eyebrow="Manage"
        title="Services"
        subtitle="Add, edit, or toggle visibility of services shown on the public site."
        actions={
          <Button
            component={Link}
            to="/dash/addservice"
            className={classes.primaryBtn}
            startIcon={<AddIcon />}
          >
            Add Service
          </Button>
        }
      />

      <Box className={classes.tableWrap}>
        <table id="services_table" className="display" style={{ width: "100%" }}>
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Image</th>
              <th>Priority</th>
              <th>Status</th>
              <th>Added</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.map((da) => (
                <tr key={da.serv_id}>
                  <td>{da.serv_id}</td>
                  <td style={{ fontWeight: 600, color: "#1a1a1a" }}>
                    {da.serv_name}
                  </td>
                  <td>
                    <img
                      src={"/static/services/" + da.serv_image}
                      alt={da.serv_name}
                      style={{ height: 56, width: 80, objectFit: "cover" }}
                    />
                  </td>
                  <td>{da.serv_priority}</td>
                  <td>
                    {da.serv_status === 1 ? (
                      <span
                        className={`${classes.badge} ${classes.badgeActive}`}
                      >
                        <CheckCircleOutlineIcon /> Active
                      </span>
                    ) : (
                      <span
                        className={`${classes.badge} ${classes.badgeInactive}`}
                      >
                        <RemoveCircleOutlineIcon /> Inactive
                      </span>
                    )}
                  </td>
                  <td>{da.serv_date}</td>
                  <td>
                    <Box className={classes.actionCell}>
                      <Tooltip title="Edit" arrow>
                        <Link
                          to={"/dash/editservice/" + da.serv_id}
                          className={classes.iconBtn}
                          aria-label="Edit"
                        >
                          <EditOutlinedIcon />
                        </Link>
                      </Tooltip>
                      <Tooltip
                        title={
                          da.serv_status === 1 ? "Deactivate" : "Activate"
                        }
                        arrow
                      >
                        <button
                          type="button"
                          className={classes.iconBtn}
                          onClick={() => toggleStatus(da.serv_id, da.serv_status)}
                          aria-label={
                            da.serv_status === 1 ? "Deactivate" : "Activate"
                          }
                        >
                          {da.serv_status === 1 ? (
                            <VisibilityOffOutlinedIcon />
                          ) : (
                            <VisibilityOutlinedIcon />
                          )}
                        </button>
                      </Tooltip>
                    </Box>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
    </div>
  );
};
